import qs from 'qs';

// 인증은 로그인 시 발급되는 Authorization 쿠키로 처리됩니다.
// (same-origin 요청은 쿠키를 자동 전송하므로 별도 토큰 헤더가 필요 없습니다.)

const get = async (urlPath = '', params = {}) => {
  const queryString = qs.stringify(params);
  const url = `${urlPath}?${queryString}`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    });

    const jsonResponse = await response.json();
    if (!jsonResponse) {
      return null;
    } else {
      return jsonResponse;
    }
  } catch (e) {
    console.error(e);
  }

  return null;
};

const post = async (urlPath = '', params = {}, headers = {}, body = {}) => {
  const queryString = qs.stringify(params);

  try {
    const response = await fetch(`${urlPath}?${queryString}`, {
      method: 'POST',
      headers: {
        ...headers
      },
      body
    });

    const jsonResponse = await response.json();

    if (!jsonResponse) {
      return null;
    } else {
      return jsonResponse;
    }
  } catch (e) {
    console.error(e);
  }

  return null;
};

const request = async (urlPath = '', params = {}, body = {}, method = 'POST') => {
  const queryString = qs.stringify(params);

  try {
    const response = await fetch(`${urlPath}?${queryString}`, {
      method,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    });

    const jsonResponse = await response.json();

    if (!jsonResponse) {
      return null;
    } else {
      return jsonResponse;
    }
  } catch (e) {
    console.error(e);
  }

  return null;
};

export default {
  get,
  post,
  request
};
